import * as _ from 'lodash';
import { LoDashStatic } from 'lodash';

interface IPWD {
  $: JQueryStatic;
  _: LoDashStatic;
  [field: string]: any;
}

const init: IPWD = (<any>window).__PWD__ || {};

// Load jQuery
if (!init.$) {
  if ((<any>window).jQuery) {
    init.$ = (<any>window).jQuery;
  } else {
    init.$ = require('jquery');
    (<any>window).jQuery = init.$;
    (<any>window).$ = init.$;
  }
}

export default init;
